<template>
<div>
    <SelectList 
        :label="$t('infopoints.timetable_view')" 
        :options="timetableViewOptions" 
        :value="timetableViewValue" 
        @select="onSelectView" 
        :disabled="loading"
        :searchable="true" 
        :clearable="true" />

    <SelectList 
        :label="$t('infopoints.layout')" 
        :options="layoutOptions" 
        :value="layoutValue" 
        @select="onSelectLayout" 
        :disabled="loading"
        :searchable="true"
        :clearable="true" />
    
    <div class="show-layouts"><label>{{ $t('infopoints.all_layouts') }}</label><input type="checkbox" v-model="showAllLayouts"></div>

    <t-button-group>
        <t-button type="save" @click="save" :disabled="!selectionsChanged || OK || ERROR"></t-button> 
    </t-button-group>

    <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />
  
</div>
</template>


<script>
import display from '@/store/displays/display'
import infopoint from '@/store/displays/infopoint'

export default {
    props: ['item'], 
    data: function() {
        return {
            viewSelection: "",
            layoutSelection: "",
            infopointContent: null,
            loading: false,
            OK: false,
            ERROR: false,
            showAllLayouts: false
        }
    },
    computed: {
        infopoint() {
            return this.item;
        },
        timetableViews() {
            return this.$store.state.infopoint.timetableViews;
        },
        timetableViewOptions(){
            var optionList = [];
            for (var item of this.$store.state.display.displayList) {
                optionList.push({ id: item.id, label: item.id + " - " + item.name })
            }
            return optionList;
        },
        layoutOptions(){
            var optionList = [];
            for (var item of this.$store.state.infopoint.layouts) {
                var label = item.name;
                if(this.showAllLayouts){
                    optionList.push({ id: item.id, label: label, badge: item.usage, variant: "warning" })
                }
                else {
                    if(item.usage > 0) optionList.push({ id: item.id, label: label, badge: item.usage, variant: "warning" })
                }
            }

            // sorted by usage, most used first
            optionList.sort((a, b) => b.badge - a.badge);

            return optionList;
        },
        timetableViewValue(){
            return (this.infopointContent && this.infopointContent[0]) ?  this.infopointContent[0].timetableView : "";
        },
        layoutValue(){
            return (this.infopointContent && this.infopointContent[0]) ?  this.infopointContent[0].layout : "";
        },
        selectionsChanged(){
            return (this.viewSelection != this.timetableViewValue) || (this.layoutSelection != this.layoutValue);
        }
    },
    watch: {
       infopoint(){
           this.getInfopointContent();
        }
    },
    methods: {
        save(){
            this.loading = true;
            var item = {...this.infopointContent[0]};
            item.timetableView = this.viewSelection
            item.layout = this.layoutSelection;
            if(!item.infopoint)
                item.infopoint = this.infopoint.id

            this.$store.dispatch('infopoint/saveInfopointContent', item).then(response => {
                if(response.data.errorCode == 0){
                    this.infopointContent[0].timetableView = item.timetableView; 
                    this.infopointContent[0].layout = item.layout;   
                    this.OK = true;
                }
                else {
                    this.ERROR = true;
                    this.viewSelection = this.timetableViewValue;
                    this.layoutSelection = this.layoutValue;
                }
            })
            .catch( () => { this.ERROR = true; } ) 
            .finally( () => { this.loading = false; } ); 

    
        },
        onSelectView(id){
           this.viewSelection = id;
           this.clearAlerts();
        },
        onSelectLayout(id){
            this.layoutSelection = id;
            this.clearAlerts();
        },
        clearAlerts(){
            this.OK = this.ERROR = false;
        },
        getInfopointContent(){
            if(this.infopoint) {
                this.loading = true;
                this.$traveller_http.get('/traveller/restui/infopoint/getContent', { params: { "id": this.infopoint.id} })
                    .then( response => {
                        
                        this.infopointContent = response.data;
                        this.viewSelection = this.timetableViewValue;
                        this.layoutSelection = this.layoutValue;
                   
                    })
                    .catch( () => {} ) 
                    .finally( () => { this.loading = false; } ); 
 
            }
            this.clearAlerts();
        }    
    },
    created() {
        if (!this.$store.state.display) this.$store.registerModule("display", display);
        this.$store.dispatch('display/getDisplayList');

        if (!this.$store.state.infopoint) this.$store.registerModule("infopoint", infopoint);
        this.$store.dispatch('infopoint/getLayouts');

        this.getInfopointContent();
    }
}
</script>

<style scoped lang="scss">
    .show-layouts {
        float: right;
        display: flex; 
        align-items: center; 
    
        label {
            margin-right: 4px;
            margin-bottom: 0;
        }
    }



</style>